import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Component, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MortgageInterface } from '@app/interfaces/mortgage.interface';

export type CheckDataAfterRestoreDialogResult = 'check' | 'dontCheck' | 'cancel';

@Component({
    selector: 'app-dialog-confirm',
    templateUrl: './check-data-after-restore-dialog.component.html',
    styleUrls: ['./check-data-after-restore-dialog.component.scss'],
    imports: [MatDialogModule, DatePipe, MatButtonModule],
})
export class CheckDataAfterRestoreDialogComponent {
    dialogRef = inject<MatDialogRef<CheckDataAfterRestoreDialogComponent>>(MatDialogRef);
    mortgage = inject<MortgageInterface>(MAT_DIALOG_DATA);
}
